module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Домашня сторінка")]), _vm._v(" » Трекер відвідуваності")], 1), _vm._v(" "), (_vm.attendance === undefined) ? _c('div', [_c('i', [_vm._v("Завантаження...")])]) : _vm._e(), _vm._v(" "), (_vm.attendance !== undefined) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Дата:")]), _vm._v(" " + _vm._s(this.currentDate))]), _vm._v(" "), (!(_vm.currentDate in _vm.attendance)) ? _c('div', [_c('p', [_vm._v("сьогодні немає школи!")]), _vm._v(" "), _vm._l((_vm.previousDates), function(previousDate) {
    return _c('button', {
      staticClass: "btn btn-outline-dark",
      on: {
        "click": function($event) {
          _vm.setDate(previousDate)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "book"
      }
    }), _vm._v("Минула дата " + _vm._s(previousDate))], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.currentDate in _vm.attendance && _vm.upcomingBirthdays.length > 0) ? _c('div', [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.upcomingBirthdays), function(studentNumber) {
    return _c('div', [_c('li', [_vm._v(_vm._s(_vm.students[studentNumber].child_name) + " (" + _vm._s(_vm.students[studentNumber].child_birthdate) + ")")])])
  }))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.attendance[_vm.currentDate]), function(attendance, studentNumber) {
    return (attendance != '/') ? _c('div', {
      staticClass: "card",
      staticStyle: {
        "width": "100%",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('h3', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(_vm.students[studentNumber].child_name))]), _vm._v(" "), (_vm.students[studentNumber].time_slot != '') ? _c('div', [_c('icon', {
      attrs: {
        "name": "star"
      }
    }), _vm._v(" " + _vm._s(_vm.students[studentNumber].time_slot))], 1) : _vm._e(), _vm._v(" "), (_vm.students[studentNumber].child_birthdate != '') ? _c('div', [_c('icon', {
      attrs: {
        "name": "calendar"
      }
    }), _vm._v(" " + _vm._s(_vm.students[studentNumber].child_birthdate))], 1) : _vm._e(), _vm._v(" "), (_vm.students[studentNumber].parents_name != '') ? _c('div', [_c('icon', {
      attrs: {
        "name": "user"
      }
    }), _vm._v(" " + _vm._s(_vm.students[studentNumber].parents_name))], 1) : _vm._e(), _vm._v(" "), (_vm.students[studentNumber].phone_number != '') ? _c('div', [_c('icon', {
      attrs: {
        "name": "phone"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'tel:' + _vm.students[studentNumber].phone_number
      }
    }, [_vm._v(_vm._s(_vm.students[studentNumber].phone_number))])], 1) : _vm._e(), _vm._v(" "), (_vm.students[studentNumber].comment != '') ? _c('div', [_c('icon', {
      attrs: {
        "name": "comment"
      }
    }), _vm._v(" " + _vm._s(_vm.students[studentNumber].comment))], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('b-button-group', [_c('b-button', {
      attrs: {
        "variant": attendance == '*' ? 'success' : ''
      },
      on: {
        "click": function($event) {
          _vm.setAttendance(_vm.currentDate, studentNumber, '*')
        }
      }
    }, [_vm._v("присутній")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": attendance == '-' ? 'warning' : ''
      },
      on: {
        "click": function($event) {
          _vm.setAttendance(_vm.currentDate, studentNumber, '-')
        }
      }
    }, [_vm._v("Відсутній")])], 1)], 1)]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Найближчі дні народження:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf7b9b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Attendance.vue
// module id = 618
// module chunks = 1